import {
  ChakraFlex as Flex,
  ChakraHeading as Heading,
  ChakraModalCloseButton as ModalCloseButton,
} from "@airhelp/react-ui-components";
import type { HeaderProps } from "./Header.d";

const Header = ({ text, testId }: HeaderProps) => (
  <Flex pb={6} align="center" justify="space-between" data-testid={testId}>
    <Heading variant="h3" as="h3">
      {text}
    </Heading>
    <ModalCloseButton size="md" />
  </Flex>
);

export default Header;
